import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import { Text } from '@talkdesk/cobalt-react-typography'
import * as identityProviderLogos from '../../constants/images'
import { IDENTITY_PROVIDER_LOGIN } from '../../constants/ui.labels'
import { constantBuilder } from '../../utils'
import Button from '@talkdesk/cobalt-react-button'
import { Icon } from '@talkdesk/cobalt-react-icon'

const identityProviderLogoSelector = (name, brandAssetsURL) =>
  ({
    Google: identityProviderLogos.GOOGLE_LOGO(brandAssetsURL),
    Microsoft: identityProviderLogos.MICROSOFT_LOGO(brandAssetsURL),
    Salesforce: identityProviderLogos.SALESFORCE_LOGO(brandAssetsURL),
    Okta: identityProviderLogos.OKTA_LOGO(brandAssetsURL),
    OneLogin: identityProviderLogos.ONELOGIN_LOGO(brandAssetsURL)
  }[name])

const IdentityProviderButton = props => {
  const { name, url, brandAssetsURL, redirect, disabled } = props
  const identityProviderLogo = identityProviderLogoSelector(
    name,
    brandAssetsURL
  )

  return (
    <>
      <Button
        disabled={disabled}
        type="secondary"
        shape="full-width"
        onClick={() => redirect(url)}
      >
        {/* position:relative/absolute needed to overlay the logo — no Cobalt prop equivalent */}
        <Flex alignY="center" width="100%" style={{ position: 'relative' }}>
          {identityProviderLogo ? (
            <img
              src={identityProviderLogo}
              alt=""
              width="20"
              height="20"
              style={{ position: 'absolute', left: 0 }}
            />
          ) : (
            <Icon
              name="lock_outline"
              size="tiny"
              style={{ position: 'absolute', left: 0 }}
            />
          )}
          <Flex grow alignX="center">
            <Text as="span">
              {constantBuilder(IDENTITY_PROVIDER_LOGIN, {
                identity_provider_name: name
              })}
            </Text>
          </Flex>
        </Flex>
      </Button>
      <Box paddingTop={2} />
    </>
  )
}

export default IdentityProviderButton
